export default __webpack_public_path__ + "static/media/dimensional_info.6f94e01e.svg";